import {
  ApplicationListApplication,
  ApplicationListGeneralState,
  ApplicationsChangeData,
} from './';
import { ApplicationListResponse } from 'src/types/rest/tenant';

interface GetApplicationsChangesProps {
  current: ApplicationListApplication[];
  initial: ApplicationListApplication[];
}

export const getApplicationsChanges = ({
  current,
  initial,
}: GetApplicationsChangesProps): ApplicationsChangeData => {
  const removedApplications: ApplicationListApplication[] = [];
  const addedApplications: ApplicationListApplication[] = [];

  for (let i = 0; i < current.length; i++) {
    const curr = current[i];
    const original: ApplicationListApplication | undefined = initial[i];

    // Process changes to initial items
    if (original) {
      if (curr.isMarkedForDeletion) {
        removedApplications.push(curr);

        continue;
      }
    }

    // Process new additions
    if (!original) {
      addedApplications.push(curr);
    }
  }

  return {
    addedApplications,
    removedApplications,
  };
};

interface GetGeneralChangedProps {
  current: ApplicationListGeneralState;
  initial: ApplicationListGeneralState;
}

export const getGeneralIsChanged = ({
  current,
  initial,
}: GetGeneralChangedProps): boolean => {
  if (current.name !== initial.name) {
    return true;
  }

  if (
    current.managers.length !== initial.managers.length ||
    current.owners.length !== initial.owners.length
  ) {
    return true;
  }

  if (
    initial.managers.some((i) => !current.managers.find((c) => c.id === i.id))
  ) {
    return true;
  }

  if (initial.owners.some((i) => !current.owners.find((c) => c.id === i.id))) {
    return true;
  }

  return false;
};

interface GetManagingApplicationsChangedProps {
  current: ApplicationListResponse['managingApplications'];
  initial: ApplicationListResponse['managingApplications'];
}

export const getManagingApplicationsIsChanged = ({
  current,
  initial,
}: GetManagingApplicationsChangedProps): boolean => {
  if (current?.length !== initial?.length) {
    return true;
  }

  if (initial?.some((i) => !current?.find((c) => c.id === i.id))) {
    return true;
  }

  return false;
};
